<template>
  <button
     class="button-resize-toggler"
    :style="style"
    :class="[`theme-${theme}`, { 'is-expanded': !collapsed }]"
    @click="onClick">
  </button>
</template>
  <!-- :class="{ 'is-expanded': isExpanded }" -->

<script>
export default {
  name: 'button-resize-toggler',
  props: {
    collapsed: {
      type: Boolean,
      required: true,
      default: false,
    },
    verticalCorrection: {
      required: false,
      default: '(100% - 4.25em - 1em - 36px) / 2',
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
  },
  data() {
    return {
      style: null,
    };
  },
  methods: {
    onClick(event) {
      event.target.blur();
      this.$emit('click');
    },
  },
  created() {
    this.style = `top: -webkit-calc(${this.verticalCorrection}); top: -moz-calc(${this.verticalCorrection}); top: calc(${this.verticalCorrection});`;
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .button-resize-toggler {
    width: 24px;
    height: 36px;
    border: none;
    right: -12px;
    top: calc(50%);
    cursor: pointer;
    background: none;
    position: absolute;
    color: transparent;
    top: -moz-calc(50%);
    top: -webkit-calc(50%);
    &:before, &:after {
      width: 2px;
      right: 3px;
      content: '';
      height: 8px;
      position: absolute;
      border-radius: 16px;
      transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      background-color: darken(#DBE2EF, 10%);
      -webkit-transition: -webkit-transform 200ms ease-in-out, transform 200ms ease-in-out, opacity 300ms ease-in-out;
      transition: -ms-transform 200ms ease-in-out, -webkit-transform 200ms ease-in-out, transform 200ms ease-in-out, opacity 300ms ease-in-out;
    }
    &:before {
      top: 10px;
      transform-origin: 1px 7px;
      -ms-transform-origin: 1px 7px;
      -webkit-transform-origin: 1px 7px;
    }
    &:after {
      top: 16px;
      transform-origin: 1px 1px;
      -ms-transform-origin: 1px 1px;
      -webkit-transform-origin: 1px 1px;
    }
    &:hover, &:focus {
      right: -15px;
      outline: none;
      cursor: pointer;
      &:before, &:after {
        background-color: darken($turquoise, 5%);
      }
    }
    &:hover:before, &:focus:before {
      transform: rotate(-40deg);
      -ms-transform: rotate(-40deg);
      -webkit-transform: rotate(-40deg);
    }
    &:hover:after, &:focus:after {
      transform: rotate(40deg);
      -ms-transform: rotate(40deg);
      -webkit-transform: rotate(40deg);
    }

    &.is-expanded {
      &:hover, &:focus {
        right: -15px;
      }
      &:hover:before, &:focus:before {
        transform: rotate(40deg);
        -ms-transform: rotate(40deg);
        -webkit-transform: rotate(40deg);
      }
      &:hover:after, &:focus:after {
        transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
      }
    }

    &.is-right-side {
      left: -23px;
      right: inherit;
      &:before, &:after {
        left: 13px;
      }
      &:hover:before, &:focus:before {
        transform: rotate(40deg);
        -ms-transform: rotate(40deg);
        -webkit-transform: rotate(40deg);
      }
      &:hover:after, &:focus:after {
        transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
      }
      &.is-expanded {
        &:hover:before, &:focus:before {
          transform: rotate(-40deg);
          -ms-transform: rotate(-40deg);
          -webkit-transform: rotate(-40deg);
        }
        &:hover:after, &:focus:after {
          transform: rotate(40deg);
          -ms-transform: rotate(40deg);
          -webkit-transform: rotate(40deg);
        }
      }
    }

    &.is-top-side {
      bottom: -26px;
      left: calc(50% - 12px);
      top: inherit !important;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      &:before, &:after {
        right: 10px;
      }
    }

    &.is-on-top {
      left: calc(50% - 12px);
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      &:before, &:after {
        right: 10px;
      }
    }

    &.is-bottom-side {
      bottom: 0;
      left: calc(50% - 12px);
      top: inherit !important;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      &:before, &:after {
        right: 10px;
      }
    }

    &.theme-error {
      &:before, &:after {
        background-color: #db9696;
      }
      &:hover, &:focus {
        &:before, &:after {
          background-color: #aa1a1a;
        }
      }
    }

    &.theme-gray {
      &:before, &:after {
        background-color: #adbcc3;
      }
      &:hover, &:focus {
        &:before, &:after {
          background-color: #607d8b;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/button/button-resize-toggler.vue